import { createAction, props } from '@ngrx/store';

export const updateSearchId = createAction('[Search] Update By Search Id', props<{id: string; searchTerm: string}>());
export const removeSearchId = createAction('[Search] Remove Search Id', props<{ id: string }>());
